import { sitesApi, blogApi } from '../../api/client';
import type { SiteContentSnapshot } from './downgradeCompliance';
import type { BlogPost } from '../../schemas/validation';

async function fetchAllBlogPosts(siteId: string): Promise<BlogPost[]> {
  const all: BlogPost[] = [];
  let page = 1;
  const limit = 100;
  for (;;) {
    const res = await blogApi.posts.list(siteId, { page, limit });
    all.push(...res.posts);
    if (page >= res.pagination.totalPages) break;
    page += 1;
  }
  return all;
}

export async function loadSiteContentSnapshots(): Promise<SiteContentSnapshot[]> {
  const sites = await sitesApi.list();
  const out: SiteContentSnapshot[] = [];
  for (const site of sites) {
    const pages = await sitesApi.getPages(site.id);
    let posts: { id: string; title: string }[] = [];
    try {
      const rawPosts = await fetchAllBlogPosts(site.id);
      posts = rawPosts.map(p => ({ id: p.id, title: p.title?.trim() || 'Untitled post' }));
    } catch (e: unknown) {
      const err = e as { status?: number };
      if (err?.status && err.status !== 404) {
        console.warn('loadDowngradeSnapshots: blog list failed for site', site.id, e);
      }
    }
    out.push({
      siteId: site.id,
      siteName: site.name,
      pageCount: pages.length,
      blogPostCount: posts.length,
      pages: pages.map(p => ({ id: p.id, title: p.title?.trim() || 'Untitled page' })),
      posts,
    });
  }
  return out;
}
